import { Text } from '../Text';

export const Subheading = Text.withProps({ variant: 'subheading' }, { name: 'Subheading' });
